import { render } from "./IncomeChart.vue?vue&type=template&id=698f80ca&scoped=true"
import script from "./IncomeChart.vue?vue&type=script&lang=js"
export * from "./IncomeChart.vue?vue&type=script&lang=js"

import "./IncomeChart.vue?vue&type=style&index=0&id=698f80ca&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698f80ca"]])

export default __exports__